const stringToDate = (inputString) => {
  return new Date(inputString);
};

const dateToisoString = (inputDate) => {
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const convertedDate = inputDate.toLocaleString("en-GB", {
    timeZone: localTimeZone
  });

  const splitDate = convertedDate?.split(",");
  if (splitDate.count === 0) {
    throw new Error("No valid date found for conversion");
  }

  const splitDateFormat = splitDate[0]?.split("/");
  if (splitDate.count === 0) {
    throw new Error("No valid date found for conversion");
  }

  let day = splitDateFormat[0];
  let month = splitDateFormat[1];
  let year = splitDateFormat[2];

  const isoString = year + "-" + month + "-" + day + "T00:00:00.000Z";
  return isoString;
};

export const convertDate = (inputString) => {
  const dateObj = stringToDate(inputString);
  return dateToisoString(dateObj);
};
